import { render, staticRenderFns } from "./MainOrdenes.vue?vue&type=template&id=befc796c"
import script from "./MainOrdenes.vue?vue&type=script&lang=js"
export * from "./MainOrdenes.vue?vue&type=script&lang=js"
import style0 from "./MainOrdenes.vue?vue&type=style&index=0&id=befc796c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports